import { useState, useEffect } from 'react';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function getTimeLeft(): TimeLeft {
  const launch = new Date('2026-07-04T00:00:00Z').getTime();
  const now = Date.now();
  const diff = Math.max(0, launch - now);
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

export default function CountdownStrip() {
  const [time, setTime] = useState<TimeLeft>(getTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => setTime(getTimeLeft()), 1000);
    return () => clearInterval(interval);
  }, []);

  const pad = (n: number) => String(n).padStart(2, '0');

  const stats = [
    { label: 'Days Remaining', value: String(time.days), color: '#C9A84C' },
    { label: 'Hours', value: pad(time.hours), color: '#F5F0E8' },
    { label: 'Minutes', value: pad(time.minutes), color: '#F5F0E8' },
    { label: 'Seconds', value: pad(time.seconds), color: '#F5F0E8' },
    { label: 'Years of Legacy', value: '1986', color: '#8B3A2A' },
  ];

  return (
    <div className="w-full flex flex-wrap items-center justify-center gap-8 md:gap-16 py-10 px-6">
      {stats.map((stat, i) => (
        <div key={stat.label} className="flex flex-col items-center gap-1">
          <span
            className="text-[10px] tracking-[0.25em] uppercase"
            style={{ fontFamily: "'Inter', sans-serif", color: '#9A9A8A' }}
          >
            {stat.label}
          </span>
          <span
            className="text-4xl md:text-5xl font-light leading-none tabular-nums"
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              color: stat.color,
              transition: 'color 0.3s',
            }}
          >
            {stat.value}
          </span>
          {i < stats.length - 1 && (
            <span
              className="hidden md:block absolute"
              style={{ color: '#C9A84C', marginTop: '24px', marginLeft: '120px', fontSize: '24px' }}
            />
          )}
        </div>
      ))}
    </div>
  );
}
